import { VM_TASK_DEFAULT_CATEGORIES_RIDS } from 'constants/baseValues'

export const DEFAULT_CATEGORIES = [
  'Fachada + Laterais',
  'Vitrine Principal',
  'Vitrine Secundária',
  'Tablado Principal',
  'Tablado Secundário',
  'Araras Femininas',
  'Araras Beach Femininas',
  'Arara Kids',
  'Araras Masculinas',
  'Mesa Mood',
  'Espaços de Experiência e Atendimento',
  'Provador',
  'Fachada Lateral Direita',
  'Fachada Lateral Esquerda',
  'Arara Solo',
  'Arara Comfy',
  'Painel Acessórios',
  'Foto Frente Loja Inteira',
  'Exposição Tênis Livre',
  'Ação Compre e Ganhe',
  'Produtos Mais Vendidos + Mta',
  'Check-in Comunicações',
]

export interface TaskCategory {
  name: string
}
export const normalizeCategoryName = (name: string) => name.trim().toLocaleLowerCase()
export function parseTaskCategories(value: unknown): TaskCategory[] {
  if (!Array.isArray(value)) return []

  const names = new Set<string>()

  return value.reduce<TaskCategory[]>((categories, category) => {
    if (!category || typeof category.name !== 'string' || !category.name.trim()) return categories

    const name = category.name.trim()
    const key = normalizeCategoryName(name)

    if (!names.has(key)) {
      names.add(key)
      categories.push({ name })
    }
    return categories
  }, [])
}
export function categoryOptions(rid: string, custom: TaskCategory[]): TaskCategory[] {
  const presets = VM_TASK_DEFAULT_CATEGORIES_RIDS.includes(rid) ? DEFAULT_CATEGORIES.map((name) => ({ name })) : []

  return parseTaskCategories([...presets, ...custom])
}
